import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { utmLoad } from "../Redux/Actions/userActions";
import { utmData } from "../Request/UserRequests";

function UtmCodes(props) 
{
    const dispatch = useDispatch();
    const utmLoaded = useSelector( ( state ) => state.user.utmLoad );
    const search = useLocation().search;
    const utmSource = new URLSearchParams( search ).get( 'utmSource' );
    const utmCampaign = new URLSearchParams( search ).get( 'utmCampaign' );
    const utmL = new URLSearchParams( search ).get( 'utmL' );
    if ( utmLoaded && ( utmSource || utmCampaign || utmL ) )
    {
        dispatch( utmLoad() );
        const utmCode = {
            utmSource,
            utmCampaign,
            utmL,
        };
        utmData( utmCode ).catch( ( err ) => console.log( err )
        );

    }

    return props.children
}

export default UtmCodes;

